module.exports = __webpack_public_path__ + "static/media/logo.5d6b7792.png";